import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router';
import * as libraryActions from '~/library/actions';
import Helpers from '~/utils/Helpers';
import StringService from '~/utils/StringService';
import { Table, Thead, Th, Tr, Td } from 'SourceClear-Reactable';
import CvssService from '~/utils/CvssService';
type LibraryViewVersionVulnerabilitiesProps = {
  libraryState: object;
  actions: object;
};
class LibraryViewVersionVulnerabilities extends React.Component<
  LibraryViewVersionVulnerabilitiesProps,
  {}
> {
  componentDidMount() {
    const { libraryState } = this.props;
    const {
      component,
      version,
      isLoadingVersionVulnerabilities,
      versionVulnerabilityErrors = {},
    } = libraryState;
    if (version && !_.isEmpty(component) && versionVulnerabilityErrors[version]) {
      this.props.actions.maybeLoadVersionVulnerabilities(version);
    }
    if (
      version &&
      !_.isEmpty(component) &&
      !isLoadingVersionVulnerabilities &&
      !versionVulnerabilityErrors[version]
    ) {
      this.props.actions.maybeLoadVersionVulnerabilities(version);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { libraryState } = nextProps;
    const {
      component,
      version,
      isLoadingVersionVulnerabilities,
      versionVulnerabilityErrors = {},
    } = libraryState;
    if (
      version &&
      !_.isEmpty(component) &&
      !isLoadingVersionVulnerabilities &&
      !versionVulnerabilityErrors[version]
    ) {
      this.props.actions.maybeLoadVersionVulnerabilities(version);
    }
  }
  getFilteredVulnerabilities() {
    const { libraryState } = this.props;
    const {
      version,
      vulnerabilitiesByVersion = {},
      versionVulnerabilityFilter = '',
    } = libraryState;
    let vulnerabilities = vulnerabilitiesByVersion[version] || [];
    if (!versionVulnerabilityFilter) {
      return vulnerabilities;
    }
    return vulnerabilities.filter(vuln => {
      let { title = '' } = vuln;
      return title.toLowerCase().indexOf(versionVulnerabilityFilter) > -1;
    });
  }
  updateFilter = e => {
    const filter = e.target.value;
    this.props.actions.updateVersionVulnerabilityFilter(filter.toLowerCase());
  };
  render() {
    const { libraryState } = this.props;
    const {
      version = '',
      isLoadingVersionVulnerabilities = false,
      versionVulnerabilityFilter = '',
      versionVulnerabilityErrors = {},
      component,
      cvss,
    } = libraryState;
    const { libraryModel = {} } = component;
    const { versions = [] } = libraryModel;
    const versionsFiltered = versions.filter(version => version.version !== 'HEAD');
    const isVersionExisting = _.some(versionsFiltered, { version: version });
    let vulnData = [];
    if (!version) {
      return <div />;
    }
    const isCvss3Selected = cvss === 'cvss3' && CvssService.isCvss3Enabled();
    let filteredVulnerabilities = this.getFilteredVulnerabilities() || [],
      sortedVulns = _.sortBy(filteredVulnerabilities, vuln => {
        return vuln.nvdCvssScore || vuln.srcclrCvssScore;
      }).reverse(),
      vulnElements = [],
      headerRow,
      filterElement;
    if (isLoadingVersionVulnerabilities) {
      headerRow = null;
      filterElement = null;
      vulnElements = <div key="vulns-loading">Loading vulnerabilities for {version}...</div>;
    } else if (versionsFiltered.length === 0) {
      vulnElements = <div key="vulns-load-error">No versions available.</div>;
    } else if (versionVulnerabilityErrors[version]) {
      headerRow = null;
      filterElement = null;
      vulnElements = <div key="vulns-load-error">Error loading vulnerabilities for {version}</div>;
    } else if (!isVersionExisting) {
      vulnElements = (
        <div key="vulns-load-error">
          Version <span className="text--italic">{version}</span> not found. Please select another
          version.
        </div>
      );
    } else {
      sortedVulns.forEach(vuln => {
        const {
          id: vulnId,
          title,
          disclosureDate,
          srcclrCvss3Score,
          nvdCvss3Score,
          srcclrCvssScore,
          nvdCvssScore,
        } = vuln;
        const cvssScore = isCvss3Selected
          ? Helpers.getFirstNonNull([nvdCvss3Score, srcclrCvss3Score])
          : Helpers.getFirstNonNull([nvdCvssScore, srcclrCvssScore]);
        const cvssVectorLevel = isCvss3Selected
          ? CvssService.getCvss3Severity(cvssScore)
          : CvssService.getCvssSeverity(cvssScore);
        const riskColorClass = CvssService.getRiskColorClassByVectorLevel(cvssVectorLevel);
        const formattedDisclosureDate = disclosureDate
          ? Helpers.formatDate(vuln.disclosureDate)
          : 'n/a';
        const hasCVE = +vuln.cveDigits && +vuln.cveYear;
        let cveElement;
        const artifactUrl = StringService.createSEOVulnItemUrl(vuln.title, vuln.language, vuln.id);
        const hasExploits = !!vuln.hasExploits;
        if (hasCVE) {
          cveElement = (
            <a
              className="inline-block link--primary"
              target="_blank"
              href={
                'https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-' +
                vuln.cveYear +
                '-' +
                vuln.cveDigits
              }
            >
              {vuln.cveYear}-{vuln.cveDigits}
            </a>
          );
        } else {
          cveElement = <div>No CVE</div>;
        }
        vulnData.push(
          <Tr key={`${vulnId}-${title}`}>
            <Td column="severity">
              <div
                className={`text--center color--white pv-- phone--pl0 phone--pr0 ${riskColorClass}`}
              >
                {cvssScore}
              </div>
            </Td>
            <Td column="issue">
              <div className="col-9-10">
                <Link className="link--primary" to={artifactUrl}>
                  {title}
                </Link>
              </div>
            </Td>
            <Td column="disclosed">{formattedDisclosureDate}</Td>
            <Td column="cve">{cveElement}</Td>
            <Td column="exploits">{hasExploits ? 'yes' : 'no'}</Td>
          </Tr>
        );
      });
      vulnElements = (
        <Table
          className="reactable-table reactable-vulns min-height--205"
          id="reactable-vulns"
          itemsPerPage={4}
          pageButtonLimit={10}
          hideFilterInput
          noDataText="No vulnerabilities found for selected version."
        >
          <Thead>
            <Th column="severity" className="col-1-10">
              <strong>Severity</strong>
            </Th>
            <Th column="issue" className="col-3-5">
              <strong>Issue</strong>
            </Th>
            <Th column="disclosed" className="col-1-10">
              <strong>Disclosed</strong>
            </Th>
            <Th column="cve" className="col-1-10">
              <strong>CVE</strong>
            </Th>
            <Th column="exploits" className="col-1-10">
              <strong>Exploits</strong>
            </Th>
          </Thead>
          {vulnData}
        </Table>
      );
      filterElement = (
        <input
          name="version-vulns"
          className="col-1-3 phone--col-1-1"
          type="text"
          placeholder="Filter by issue name"
          defaultValue={versionVulnerabilityFilter}
          onChange={this.updateFilter}
          autoFocus
        />
      );
      if (vulnElements.length === 0) {
        headerRow = null;
        filterElement = null;
        vulnElements = <div key="vulns-none">No vulnerabilities for {version}</div>;
      }
    }
    return (
      <div className="grid pb+">
        <div className="grid__item col-1-1">{filterElement}</div>
        <div className="grid__item col-1-1">{headerRow}</div>
        <div className="grid__item col-1-1 mt">{vulnElements}</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(libraryActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewVersionVulnerabilities);
